module.exports = __webpack_public_path__ + "static/img/路灯bg@2x.c1b6c599.png";